/* this file needs to be in ES5 to work in browser. Webpack you're using assumes that files from node_modules are already bundled and parsed */
module.exports = {
    // eslint-disable-next-line object-shorthand
    getSettings: function () {
        // eslint-disable-next-line no-undef
        return window['--pint-frontend-settings'] || {};
    },
};
